// Every word of the college page's "Ask Astra about <School>" box and the
// Astra sheet it opens (#3262; founder pick A of Sets 1a and 1b of the Astra
// entry mocks, 2026-10-06: https://claude.ai/artifact/VUUhrLZjrLsT3zf8YU2BLq).
// The lines are the mock's.
//
// The three seeds come from the three most asked kinds of question (test
// policy, odds, cost) and name the school in words, so the open chat needs no
// school scope of its own. Each is built from the page's own data:
//   - testing follows the school's stated policy. A test-blind school's seed
//     asks WHETHER scores are looked at, never how to use them (product
//     invariant 4: a test-blind school never has a score framed as mattering).
//   - odds is "How hard is it to get into <School>?". The mock's "...for my
//     major?" was asked on the deployed route under the preview token
//     (2026-10-06, UCLA, UC Berkeley, UIUC): all three times Astra answered
//     with a question back ("which major?") and no figure, while the plain
//     question got the rate, the admitted GPA range and the testing policy.
//   - cost asks what families pay, which the chat answers from the net price
//     by income (it asks for the income range).

export const ASK_BOX = {
    title: (s) => `Ask Astra about ${s}`,
    line: 'Free, no sign-in',
    placeholder: (s) => `Ask anything about ${s}`,
    ariaLabel: (s) => `Ask Astra a question about ${s}`,
    go: 'Ask',
    foot: (s) => `Answers come from ${s}'s own data, with the source on each one.`,
};

export const SHEET = {
    name: 'Astra',
    line: (s) => `Asking about ${s} · no sign-in`,
    close: 'Close',
    closeLabel: (s) => `Close Astra and go back to the ${s} page`,
    greeting: (s) => `Ask me anything about ${s}. I answer from ${s}'s own data, with the source on every answer.`,
    placeholder: (s) => `Ask another question about ${s}`,
    dialogLabel: (s) => `Astra, asking about ${s}`,
};

// A typed question that does not name the school is sent as "About UCLA: ..."
// (the words the visitor sees in their own bubble), so Astra reads the school
// the box is about rather than asking which one.
export const aboutSchool = (s, q) => `About ${s}: ${q}`;

/** The testing question for a school, from its stated policy (shared with the News box). */
export function testingSeed(c, s) {
    const t = c.testing || {};
    if (t.blind) return `Does ${s} look at SAT or ACT scores at all?`;
    if (/required/i.test(String(t.policy || ''))) return `Does ${s} require the SAT or ACT?`;
    return `Should I send my SAT or ACT scores to ${s}?`;
}

/** The box's three seeds for a college page: [{id, topic, q}], testing first. */
export function collegeSeeds(c) {
    const s = c.shortName || c.name;
    return [
        { id: 'college_testing', topic: 'test_policy', q: testingSeed(c, s) },
        { id: 'college_odds', topic: 'school_odds', q: `How hard is it to get into ${s}?` },
        { id: 'college_cost', topic: 'cost_aid', q: `What do families like mine pay at ${s}?` },
    ];
}

const words = (t) => ` ${String(t || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim()} `;

/** True when the text names the school: its name, short name or a nickname,
 *  as whole words ("Is UCLA test-blind?", not "uclan"). */
export function namesSchool(text, c) {
    const hay = words(text);
    return [c.name, c.shortName, ...(c.aliases || [])]
        .map(words)
        .some((n) => n.trim().length >= 2 && hay.includes(n));
}

/** What a question from the box or the sheet's first turn sends. */
export function scopedQuestion(q, c) {
    const s = c.shortName || c.name;
    return namesSchool(q, c) ? q : aboutSchool(s, q);
}
